// AppInsights.js
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import { UATConstants } from 'src/Common/Models/UATConstants';

const browserHistory = createBrowserHistory();
const reactPlugin: any = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: UATConstants.InsightsInstrumentationKey,
    autoTrackPageVisitTime: true,
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});

appInsights.loadAppInsights();

export { reactPlugin, appInsights };
